import React, { useEffect } from "react";
import { Grid } from "@mui/material";

import "./swiftMessages.css";
import useSnackBar from "../../Hooks/useSnackBar";
import MessagesTable from "./MessagesTable";
import { searchSwiftMessages } from "../state/actions";
import { useDispatch, useSelector } from "react-redux";

const SwiftMessages = ({ filters }) => {
  const dispatch = useDispatch();
  const pageSize = useSelector((state) => state.swiftMessages.pageSize);

  const { error, snackbar, success } = useSnackBar();

  useEffect(() => {
    dispatch(
      searchSwiftMessages(
        {
          searchCriteria: { ...filters },
          pageNumber: 1,
          pageSize,
        },
        error
      )
    );
  }, [dispatch, error, filters, pageSize]);

  return (
    <>
      {snackbar}
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            padding: 5,
            background: "#F8FAFB",
          }}
        >
          <MessagesTable error={error} filters={filters} success={success}/>
        </Grid>
      </Grid>
    </>
  );
};

export default SwiftMessages;
